var map = {
	"./academia-img1.svg": 520,
	"./academia-img2.svg": 521,
	"./academia-img3.svg": 522,
	"./business-img1.svg": 523,
	"./business-img2.svg": 524,
	"./business-img3.svg": 525,
	"./students-img1.svg": 526,
	"./students-img2.svg": 527,
	"./students-img3.svg": 528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;